type IRatingProps = {
    stars: number[]
}

export const rating_classification: IRatingProps[] = [
    {
        stars: [0, 0, 0, 0, 0]
    },
    {
        stars: [2, 0, 0, 0, 0]
    },
    {
        stars: [2, 2, 0, 0, 0]
    },
    {
        stars: [2, 2, 2, 0, 0]
    },
    {
        stars: [2, 2, 2, 2, 0]
    },
    {
        stars: [2, 2, 2, 2, 2]
    }
]
